import {SVGProps } from "react";

interface DeleteButtonSVGProps {
    iconColor?: string;
}

const DeleteButtonSVG= (props: DeleteButtonSVGProps) => {
    return (
        <div>
            <button className="opacity-90 hover:opacity-100 flex-shrink-0">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6h16" stroke={props.iconColor || "currentColor"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17 6v0 13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7 6" stroke={props.iconColor || "currentColor"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke={props.iconColor || "currentColor"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
           
        </div>
    );
}

export default DeleteButtonSVG;